// Import parent theme's app.js
import '@parent/app.js';

console.log('Yes, I am a child theme!');



// WEBPACK FOOTER //
// ./scripts/app.js